import { createNS } from "@ontologies/core";
/** Function to create arbitrary terms within the 'Resource Description Framework' ontology */
export const ns = createNS("http://www.w3.org/1999/02/22-rdf-syntax-ns#");
/** The datatype of RDF literals storing fragments of HTML content */
export const HTML = ns("HTML");
/** The datatype of language-tagged string values */
export const langString = ns("langString");
/** The class of plain (i.e. untyped) literal values, as used in RIF and OWL 2 */
export const PlainLiteral = ns("PlainLiteral");
/** The class of RDF properties. */
export const Property = ns("Property");
/** The class of RDF statements. */
export const Statement = ns("Statement");
/** The class of unordered containers. */
export const Bag = ns("Bag");
/** The class of ordered containers. */
export const Seq = ns("Seq");
/** The class of containers of alternatives. */
export const Alt = ns("Alt");
/** The class of RDF Lists. */
export const List = ns("List");
/** The empty list, with no items in it. If the rest of a list is nil then the list has no more items in it. */
export const nil = ns("nil");
/** The datatype of XML literal values. */
export const XMLLiteral = ns("XMLLiteral");
/** The subject is an instance of a class. */
export const type = ns("type");
/** The subject of the subject RDF statement. */
export const subject = ns("subject");
/** The predicate of the subject RDF statement. */
export const predicate = ns("predicate");
/** The object of the subject RDF statement. */
export const object = ns("object");
/** Idiomatic property used for structured values. */
export const value = ns("value");
/** The first item in the subject RDF list. */
export const first = ns("first");
/** The rest of the subject RDF list after the first item. */
export const rest = ns("rest");
export default {
    /** Function to create arbitrary terms within the 'Resource Description Framework' ontology */
    ns,
    /** The datatype of RDF literals storing fragments of HTML content */
    HTML,
    /** The datatype of language-tagged string values */
    langString,
    /** The class of plain (i.e. untyped) literal values, as used in RIF and OWL 2 */
    PlainLiteral,
    /** The class of RDF properties. */
    Property,
    /** The class of RDF statements. */
    Statement,
    /** The class of unordered containers. */
    Bag,
    /** The class of ordered containers. */
    Seq,
    /** The class of containers of alternatives. */
    Alt,
    /** The class of RDF Lists. */
    List,
    /** The empty list, with no items in it. If the rest of a list is nil then the list has no more items in it. */
    nil,
    /** The datatype of XML literal values. */
    XMLLiteral,
    /** The subject is an instance of a class. */
    type,
    /** The subject of the subject RDF statement. */
    subject,
    /** The predicate of the subject RDF statement. */
    predicate,
    /** The object of the subject RDF statement. */
    object,
    /** Idiomatic property used for structured values. */
    value,
    /** The first item in the subject RDF list. */
    first,
    /** The rest of the subject RDF list after the first item. */
    rest
};
